export default __webpack_public_path__ + "static/media/PainHign.aa51b44e.svg";